module.exports = __webpack_public_path__ + "img/zhuanpan.965f2bbf.png";